import React, { useEffect } from 'react';
import { useParams } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { eventSet } from '../../store/eventSlice';
import useApiGet from '../../hooks/useApiGet';
import Loader from '../common/Loader';
import Error from '../common/Error';
import ActivityList from './ActivityList';
import Filter from '../filter/Filter';

const Activities = () => {
	const { i18n } = useTranslation();
    const { id, lang } = useParams();
	const dispatch = useDispatch();
	const method = '/events/' + id;
	const [ data, error, isLoading ] = useApiGet({ method });

	useEffect(() => {
		if(!lang) return; // если язык не установили по УРЛ, то не меняем его
		if(lang === 'en') {
			i18n.changeLanguage('en')
		} else {
			i18n.changeLanguage('ru')
		}
	}, [ lang, i18n ]);

	// TODO: Проверить - похоже что не нужен этот dispatch ни здесь, ни где бы то ни было.
	// Поскольку мы можем перейти на страницу события или экспонента минуя главную страницу,
	// мы не можем рассчитывать на то, что выбор мероприятия был сделан ранее, а значит
	// всякий раз надо запрашивать информацию о нем отдельно.
	useEffect(() => {
		if(data) dispatch(eventSet(data.event));
	}, [ data, dispatch ]);

	return (
		<div className='Content-flex'>
			{isLoading ? <Loader/> :
            <React.Fragment>
                {error ? <Error error={error}/> :
				<React.Fragment>
					{data &&
					<React.Fragment>
						<Filter event={data.event}/>
						<ActivityList event={data.event}/>
					</React.Fragment>}
                </React.Fragment>}
            </React.Fragment>}
		</div>
	);
};

export default Activities;
